import { useCallback, useMemo } from "react";
import NavbarV3 from "../../../components/NavbarV3/NavbarV3.tsx";
import CadastroViagem from "./StepperV2/CadastroViagem.js";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../contexts/ProfileContext.tsx";
import CadastroEditHeader from "../../../core/components/CadastroEditHeader.tsx";
import { motion } from "framer-motion";

function CadastrarEmbarque() {
	const { contextoEmbarque, dadosFilial } = useProfile();
	const navigate = useNavigate();

	const handleGoBack = useCallback(() => {
		navigate("/viagens/" + contextoEmbarque);
	}, []);

	const contextoFilial = useMemo(() => {
		return dadosFilial?.find((filial) => filial.contexto === contextoEmbarque)
			?.nomeFilial;
	}, [dadosFilial, contextoEmbarque]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			transition={{ duration: 0.3 }}
			className="layout-container"
		>
			<NavbarV3 title={`Cadastro de Viagens - ${contextoFilial}`} />
			<CadastroEditHeader
				dadosTitle="Dados de Viagens"
				headerTitle="Cadastro de Viagens"
				onClick={handleGoBack}
			/>
			<CadastroViagem />
		</motion.div>
	);
}

export default CadastrarEmbarque;
